import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-name-document-tableitem',
  templateUrl: './name-document-tableitem.component.html',
  styleUrls: ['./name-document-tableitem.component.css'],
  standalone: false,
})
export class NameDocumentTableitemComponent {
  constructor(private readonly router: Router) {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() row: any;

  @Input() photo = true;

  @Input() nameLength = 25;

  @Input() smallFont = false;

  @Input() type?: string;

  onClick() {
    switch (this.type) {
      case 'client':
        return this.router.navigate(['/panel/clients/details', this.row.id]);
      case 'recipient':
        return this.router.navigate(['/panel/recipients/view', this.row.id]);
      default:
        return;
    }
  }
}
